import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import * as fromStore from '../store';
import { of } from 'rxjs';
import { SetMenuTheme } from 'src/app/store';

export const NewsDetailGuard: CanActivateFn = route => {
  const store = inject(Store);
  return store
    .select(fromStore.getSelectedNewsLoaded)
    .pipe(
      tap(loaded => {
        store.dispatch(SetMenuTheme('accent'));
        if (!loaded) {
          const id = +route.params['newsId'] || +route.data['newsId'];
          store.dispatch(fromStore.LoadNewsById({ id }));
        }
      }),
      filter(loaded => loaded),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
